import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import './style.css';
//import Footer from 'components/Footer/Footer';
//import website from 'Assets/website.svg';
//import facebook from 'Assets/facebook.svg';
//import twitter from 'Assets/twitter.svg';
//import { CopyToClipboard } from 'react-copy-to-clipboard';
//import permalink from 'Assets/Permalink.svg';
//import Button from 'components/Button/Button';
//import Trending from 'components/TrendingNow/Trending';
//import { CurrentUrl } from 'utils/Helper';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import Switch from 'components/Switch/Switch';
//import PlayerVideo from 'components/VideoPlayer/VideoPlayer';
import PlayerVideo from 'components/VideoPlayer/VideoPlayerV2';
import { current_unix_stamp } from "utils/Helper";
import { search_Presentation_API, presentation_Creation_API, HeaderConfig, user_Status, user_entity_uuid } from 'Api/Api';
// , apiUrl, myHeaders_Autorized, myHeaders_With_Cache_Control, myHeaders_Auth_With_Cache_Control
import axios from 'axios';
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner'
import { withRouter } from 'react-router-dom';
//import Collapse from 'react-bootstrap/Collapse';
//import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
//import Uparrow from 'Assets/up-arrow.png';
//import Downarrow from 'Assets/down-arrow.png';
import { local_routes } from 'utils/Routes';
//import ContactReportModal from 'components/ContactReportModal/ContactReportModal';
//import Modal from "react-bootstrap/Modal";
//import home from 'Assets/home.svg';
//import { FacebookShareButton,TwitterShareButton, } from 'react-share';
//import avatar from 'Assets/avatarnew.svg';

import { supported_languages } from 'utils/supported_languages';

const legacy_language_map = {
    'en': 'en-US', // assuming more US english
    'fr': 'fr-FR', // assuming more france french
    'de': 'de-DE',
    'hi': 'hi-IN',
    'it': 'it-IT',
    'ko': 'ko-KR',
    'pt': 'pt-BR',
    'es': 'es-US', // assuming more latin american spanish
}

class EmbeddedPlayer extends Component {
    randomColors = ['#00A885', '#1775BA'];
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            presentationDetail: {},
            presentationEventsDetail: [],
            eventDetail: {},
            isLoader: true,
            open: false,
            userData: [],
            avatarImg: null,
            userSectionStatus: true,
            legacyPresenters: null,
            applaudCount: 0,
            likeLoader: false,
            label: "like",
            categories: [],
            showNextEvents: false, // embedded presentations we don't want to do this.
            friendlyUrl: null,
            videocompletedState: false,
            next_presentation_friendly_url: "",
            page_title: "PechaKucha 20x20", // default - will be changed by Helmet
            copied: false,
        };
        console.log("EmbeddedPlayer constructor");
        
    }
    
    /*
    componentDidUpdate (prevProps) {
        let { location: { pathname } } = this.props;

        if (prevProps.location.pathname === pathname) return;
        this.routeChanged();
    }

    routeChanged () {
        this.APIPromises();
    }
    */

    componentDidMount() {
        this.APIPromises();
    }

    getRemoteVttBlob = async (remote_url) => {
        let extension = remote_url.split('.').pop();
        let xhr = new XMLHttpRequest();
    
        return new Promise( function(resolve, reject) {
          xhr.open('GET', remote_url, true);
          xhr.responseType = "arraybuffer";
          xhr.onload = function () {
            let arrayBufferView = new Uint8Array(this.response);
            let blob = new window.Blob([arrayBufferView], { type: 'text/vtt' });
            //console.log("GOT BLOB",remote_url,blob);
            resolve(blob);
          };
          xhr.send();
        });
    }

    APIPromises(data) {
        this.setState({isLoader:true});
        let received_params;
        if (data !== undefined) {
            received_params = data;
        }
        else {
            received_params = this.props.match.params;
        }
        this.setState({avatarImg: null, friendly_url:received_params.friendly_url});

        //API Calls GET /rest/presentations
        let new_state = {};
        let axios_promises = [
            axios.get(`${presentation_Creation_API}/${received_params.friendly_url}`, HeaderConfig),
            axios.get(`${presentation_Creation_API}/${received_params.friendly_url}/users`, HeaderConfig),
            axios.get(`${presentation_Creation_API}/${received_params.friendly_url}/categories`, HeaderConfig),
            axios.get(`${presentation_Creation_API}/${received_params.friendly_url}/events`, HeaderConfig)
        ];
        if (user_Status === 1) {
            // for embedded player we don't want to check if they are logged in
            //axios_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}/presentations.audience?filter[applauded_time][gte]=1&attributes[0]=friendly_url`, myHeaders_Autorized));
        }
        Promise.all(axios_promises)
            .then(async ([presentationRes, userDataRes, presentationCategories, presentationEvents, likeDataApiRes]) => {
                let categories_title_tag_text = "";
                let full_name = "";
                if (presentationCategories.data) {
                    new_state.categories = presentationCategories.data;
                    // we want first or first and second categories in title. someday we want most popluar categories but we don't have that yet.
                    if (presentationCategories.data[0]) {
                        categories_title_tag_text = presentationCategories.data[0].entity_name+' ';
                    }
                    if (presentationCategories.data[1]) {
                        categories_title_tag_text = categories_title_tag_text+'& '+presentationCategories.data[1].entity_name+' ';
                    }
                    // pick random colors
                    new_state.categories.forEach(element => {
                        element.category_color = this.randomColors[Math.floor(Math.random() * this.randomColors.length)]
                    })
                }
                if (presentationRes.data) {
                    if (presentationRes.data.presentation_subtitle_vtt_url) {
                        let cc_vtt_blob = await this.getRemoteVttBlob(presentationRes.data.presentation_subtitle_vtt_url);
                        let cc_vtt_local_file_url = window.URL.createObjectURL(cc_vtt_blob);
                        presentationRes.data.cc_vtt_local_file_url = cc_vtt_local_file_url;
                        if (presentationRes.data.language_abbreviation) {
                            if (presentationRes.data.language_abbreviation in legacy_language_map) {
                                presentationRes.data.language_abbreviation = legacy_language_map[presentationRes.data.language_abbreviation];
                            }
                            let language_obj = supported_languages.find((item) => item.type === presentationRes.data.language_abbreviation);
                            console.log("LANGUAGE",presentationRes.data.language_abbreviation);
                            if (language_obj) {
                                presentationRes.data.subtitle_title = language_obj.subtitle_title;
                            } else {
                                presentationRes.data.subtitle_title = "Dothraki / Klingon";
                            }
                        }
                    }

                    presentationRes.data.categories_title_tag_text = categories_title_tag_text;
                    
                    if (presentationRes.data.legacy_presenters) {
                        new_state.legacyPresenters = presentationRes.data.legacy_presenters;
                        full_name = presentationRes.data.legacy_presenters;
                    }

                    if (presentationRes.data.entity_uuid) {
                        if (presentationRes.data.applaud_count) {
                            new_state.applaudCount = presentationRes.data.applaud_count;
                        } else {
                            new_state.applaudCount = 0;
                        }
                    } else {
                        new_state.isLoader = false;
                    }
                    
                    if (presentationRes.data.image_url) {
                        // cover (poster) image - insert pad<pad_color>_1280x720
                        let pad_color = "black";
                        let image_size = '1280x720';
                        if (presentationRes.data.pad_color) {
                            pad_color = presentationRes.data.pad_color
                        }
                        let array = presentationRes.data.image_url.split("/");
                        presentationRes.data.poster_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/pad${pad_color}_${image_size}/${array[5]}`;
                    }
                    new_state.presentationDetail = presentationRes.data;
                    
                    let date_options = { year: 'numeric', month: 'long', day: 'numeric' };
                    let created_date = new Date(new_state.presentationDetail.created_time * 1000);
                    let display_date = created_date.toLocaleDateString("en-US", date_options).toUpperCase(); // September 17, 2016
                    new_state.presentationDetail.created_date_display = "Presentation Created on "+display_date;
                    
                    // View Count API starts
                    axios.post(`${presentation_Creation_API}/${presentationRes.data.entity_uuid}/incrementCount?count_type=view`, {}, HeaderConfig)
                    // View Count API ends
                }
                if (userDataRes.data) {
                    let tempRes;
                    userDataRes.data.forEach(element => {
                        if (element.xref_data && element.xref_data.presenter_integer) {
                            if (element.firstname && element.lastname) {
                                element.full_name = element.firstname+' '+element.lastname;
                            } else if (element.lastname) {
                                element.full_name = element.lastname;
                            } else if (element.firstname) {
                                element.full_name = element.firstname;
                            } else {
                                element.full_name = 'Unknown';
                            }
                            full_name = element.full_name;
                            new_state.userData = element;
                            tempRes = element;
                            if (element.avatar_image_url) {
                                let array = element.avatar_image_url.split("/");
                                new_state.avatarImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_125x125/${array[5]}`
                            }
                            if (tempRes.xref_data !== undefined && tempRes.xref_data !== null) {
                            }
                        }
                    });
                    new_state.isLoader = false;
                }
                if (presentationEvents.data) {
                    if (presentationEvents.data.length > 0 && presentationEvents.data[0] && presentationEvents.data[0].presentations) {
                        // make sure order_integer exists and is > 0
                        presentationEvents.data[0].presentations = presentationEvents.data[0].presentations.filter( pres_data => {
                            if (pres_data.xref_data && pres_data.xref_data.order_integer && pres_data.xref_data.order_integer > 0) {
                                return true;
                            } else {
                                return false;
                            }
                        });
                        // should sort this
                        presentationEvents.data[0].presentations = presentationEvents.data[0].presentations.sort((a, b) => (a.xref_data.order_integer > b.xref_data.order_integer) ? 1 : -1);
                        // now should re-order so the next one will go next
                        let pk_slot = presentationEvents.data[0].xref_data.order_integer;
                        let before_slice = presentationEvents.data[0].presentations.slice(0,pk_slot-1);
                        let after_slice = presentationEvents.data[0].presentations.slice(pk_slot);
                        presentationEvents.data[0].presentations = after_slice.concat(before_slice);
                        new_state.presentationEventsDetail = presentationEvents.data[0].presentations;

                        new_state.eventDetail = {...presentationEvents.data[0]};
                        delete new_state.eventDetail.presentations;

                    } else {
                        new_state.eventDetail = {};
                        new_state.presentationEventsDetail = [];
                        //JBB 10/16/2019 - get related presentations via category
                        if (new_state.categories.length > 0) {
                            let presentationsearch_promises = [];
                            for (let category of new_state.categories) {
                              let params = {
                                categories_uuid: category.entity_uuid,
                                categories_text: category.entity_name,
                                sort_by: 'view_count',
                                sort_order: 'DESC',
                                limit: 15
                              }
                              //presentationsearch_promises.push(axios.get(`${search_Presentation_API}?categories_text=${category.entity_name}&sort_by=view_count&sort_order=DESC&limit=15`, HeaderConfig));
                              presentationsearch_promises.push(axios.get(`${search_Presentation_API}`, { params, ...HeaderConfig }));
                            }
                            let related_presentations_categories = await Promise.all(presentationsearch_promises);
                            let max_related_presentations = 15;
                            for (let i = 0; i < max_related_presentations; i++) {
                                for (let related_presentations_category of related_presentations_categories) {
                                    if (related_presentations_category.data.search_query_results.length > 0) {
                                        if (related_presentations_category.data.search_query_results[0].entity_info.friendly_url !== received_params.friendly_url) {
                                            new_state.presentationEventsDetail.push(related_presentations_category.data.search_query_results.shift().entity_info);
                                        }
                                    }
                                }
                            }
                        }

                    }

                    if (new_state.presentationEventsDetail.length > 0) {
                        new_state.next_presentation_friendly_url = new_state.presentationEventsDetail[0].friendly_url; // JBB for play-next-video
                    }

                    new_state.isLoader = false;
                }
                if (user_Status === 1 && likeDataApiRes && likeDataApiRes.data) {
                    new_state.label = 'like';
                    for (let element of likeDataApiRes.data) {
                        if (element.friendly_url === received_params.friendly_url) {
                            if (element.xref_data && element.xref_data.applauded_time && element.xref_data.applauded_time > 0) {
                                new_state.label = 'unlike';
                                break;
                            }
                        }
                    }

                }
                if (!full_name) {
                    full_name = "PechaKucha";
                }
                new_state.page_title = full_name+' '+categories_title_tag_text+' Video Presentation: '+new_state.presentationDetail.entity_name;

                // build event section data
                if (new_state.eventDetail) {
                    if (new_state.eventDetail.start_time) {
                        let date_options = { year: 'numeric', month: 'long', day: 'numeric' };
                        let event_date = new Date(new_state.eventDetail.start_time * 1000);
                        let display_date = event_date.toLocaleDateString("en-US", date_options).toUpperCase(); // September 17, 2016
                        if (new_state.eventDetail.start_time < current_unix_stamp) {
                            new_state.eventDetail.presentation_date_display = 'PRESENTED ON '+display_date;
                        } else {
                            new_state.eventDetail.presentation_date_display = 'SCHEDULED FOR '+display_date;
                        }

                    }
                    if (new_state.eventDetail.locations_text && new_state.eventDetail.locations[0]) {
                        new_state.eventDetail.location_display = new_state.eventDetail.locations_text.toUpperCase();
                        new_state.eventDetail.city_friendly_url = new_state.eventDetail.locations[0].friendly_url;
                    }
                    if (new_state.eventDetail.locations_text && new_state.eventDetail.volume_integer) {
                        new_state.eventDetail.event_name_display = new_state.eventDetail.locations_text.toUpperCase()+' VOL '+new_state.eventDetail.volume_integer;
                        if (new_state.eventDetail.entity_name && new_state.eventDetail.entity_name.toUpperCase() !== new_state.eventDetail.event_name_display) {
                            new_state.eventDetail.event_name_display += ' "'+new_state.eventDetail.entity_name.toUpperCase()+'"';
                        }
                    } else if (new_state.eventDetail.entity_name) {
                        new_state.eventDetail.event_name_display = new_state.eventDetail.entity_name.toUpperCase();
                    }
                }

                // sort categories by entity_name
                new_state.categories = new_state.categories.sort((a, b) => (a.entity_name > b.entity_name) ? 1 : -1);

                this.setState(new_state);
            });

    }

    onVideoPlayComplete = async (userData) => {
        if (userData === true && this.state.showNextEvents) {
            if (this.state.next_presentation_friendly_url) {
                this.props.history.push(local_routes.presentations+"/"+this.state.next_presentation_friendly_url);
            }
        }
    };

    // moreEventCheck will facebook_get_access_token_api
    toggleDiv() {
        this.setState({showNextEvents:!this.state.showNextEvents});
    }

    /*
    handleClick = () => {
        if (user_Status === 1) {
            // Applaud Count API starts
            this.setState({likeLoader:true});
            let decrement_flag = "";
            let new_label = 'unlike';
            if (this.state.label === 'unlike') {
                decrement_flag = "&decrement=true";
                new_label = 'like';
            }
            axios.post(`${presentation_Creation_API}/${this.state.presentationDetail.entity_uuid}/incrementCount?count_type=applaud${decrement_flag}`, {}, myHeaders_Autorized)
                .then((res) => {
                    if (res.data.message === "count not incremented - user has already done this action") {
                        this.setState({ likeLoader: false });
                        return null;
                    }
                    this.setState({applaudCount:res.data.new_count,label:new_label,likeLoader:false});

                    // now bust cache
                    axios.all([
                        axios.get(`${presentation_Creation_API}/${this.props.match.params.friendly_url}`, myHeaders_With_Cache_Control),
                        //axios.get(`${apiUrl}users/${user_entity_uuid}/presentations.audience?filter[applauded_time][gte]=1&attributes[0]=friendly_url`, myHeaders_Auth_With_Cache_Control)
                        axios.get(`${apiUrl}users/${user_entity_uuid}/presentations.audience?filter_obj=${encodeURIComponent('{"applauded_time":{"gte":1}}')}&attributes_array=${encodeURIComponent('["friendly_url"]')}`, myHeaders_Auth_With_Cache_Control)
                    ]);

                })
            // Applaud Count API ends
        }

    }
    */

    reportPresentation = async () => {
        if (user_entity_uuid) {
        } else {
        }
    }

    // Toogles modal show
    showModal = () => {
        this.setState({ show: true });
        return null;
    }
    // Toogles modal hide
    hideModal = () => {
        this.setState({ show: false });
        return null;
    }

    render() {
        const {userData} = this.state;
        //console.log("EmbeddedPlayer render",this.state.eventDetail.presentation_date_display);
        if (this.state.isLoader) {
            return (
                <FullPageSpinner />
            )
        } else {
            return (
                <React.Fragment>
                    <Helmet>
                        <title>{this.state.page_title}</title>
                    </Helmet>
                    <div className="main-section">
                        {/* Body section starts here */}
                        <section className="embedded-player-page">
                            <div className="embedded-container">
                                <div className="player-page-body">
                                    <Row style={{ "marginRight": "0px", "marginLeft": "0px"}}>
                                        <Col sm={12} md={12} lg={12} style={{ "paddingRight": "0px", "paddingLeft": "0px"}}>
                                            <Row style={{ "marginRight": "0px", "marginLeft": "0px"}}>
                                                <Col sm={12} md={12} lg={12} style={{ "paddingRight": "0px", "paddingLeft": "0px"}}>
                                                    <div className="embedded-video-player">
                                                        <PlayerVideo
                                                            presentation_data={this.state.presentationDetail}
                                                            autoPlayStatus={false}
                                                            onClickVideoPlayComplete={this.onVideoPlayComplete}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row style={{ "marginRight": "0px", "marginLeft": "0px"}}>
                                                <Col sm={12} md={12} lg={12} style={{ "paddingRight": "0px", "paddingLeft": "0px"}}>
                                                    <div className="embedded-video-det">
                                                        <NavLink target="_blank" to={`${local_routes.presentations}/${this.state.presentationDetail.friendly_url}`}>
                                                            <h1>{this.state.presentationDetail.entity_name}, by {userData.full_name}</h1>
                                                        </NavLink>
                                                    </div>
                                                </Col>
                                                <Col sm={12} md={12} lg={12} style={{ "paddingRight": "0px", "paddingLeft": "0px"}}>
                                                    <div className="embedded-playerevent">
                                                        <div className="embedded-playerevent-area">
                                                            {this.state.eventDetail.presentation_date_display ?
                                                                <h4>PECHAKUCHA {this.state.eventDetail.presentation_date_display}</h4>
                                                                : null}
                                                            {this.state.eventDetail.location_display ?
                                                               <h4>IN <NavLink target="_blank" activeStyle={{'text-decoration':'underline'}} to={`${local_routes.cities}/${this.state.eventDetail.city_friendly_url}`}>{this.state.eventDetail.location_display}</NavLink></h4>
                                                                : null}
                                                            {this.state.eventDetail.event_name_display ?
                                                                <h4>@ <NavLink target="_blank" activeStyle={{'text-decoration':'underline'}} to={`${local_routes.events}/${this.state.eventDetail.friendly_url}`}>{this.state.eventDetail.event_name_display}</NavLink></h4>
                                                                : null}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </section>
                        {/* Body section ends here */}
                    </div>
                </React.Fragment>
            )
        }
    }

}

export default withRouter(EmbeddedPlayer);
